import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {NumericFormat as NumberFormat} from "react-number-format";

import { Flex } from "../../container-components";
import { numberFieldConfig as config } from "../../util/configs";

const InputVessel = styled.input`
  border: none;
  padding: 18px 11px;
  min-width: 150px;
  border-radius: 7px;
  height: 60px;
  background: #e9f4ff;
  box-shadow: none;
  outline: none;
  transition: all 300ms ease 0s;
  z-index: 1;
  width: 100%;
  max-width: 100%;
  margin: 0px 0px 10px;
  font-size: 16px;
  // -webkit-box-shadow: 0 0 0px 1000px #e9f4ff inset;
  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #e9f4ff inset;
  }
`;

const TextAreaVessel = styled.textarea`
  border: none;
  padding: 18px 11px;
  min-width: 150px;
  border-radius: 7px;
  height: 250px;
  background: #e9f4ff;
  box-shadow: none;
  outline: none;
  transition: all 300ms ease 0s;
  z-index: 1;
  width: 100%;
  font-size: 16px;
  max-width: 100%;
  margin: 0px 0px 10px;
  resize: vertical;
  // -webkit-box-shadow: 0 0 0px 1000px #e9f4ff inset;
  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #e9f4ff inset;
  }
`;

const Select = styled.select`
  border: none;
  padding: 0;
  height: 60px;
  min-width: 250px;
  border-radius: 7px;
  background: ${(props) => props.background || "#fff"};
  box-shadow: ${(props) =>
    props.isFocused ? "0 0 0 2px rgba(24, 144, 255, 0.2)" : "none"};
  outline: "none";
  transition: "all 300ms";
  zindex: 1;
`;

const Input = ({
  value,
  style,
  className,

  placeholder,
  type,
  required,
  name,
  error,
  margin,
  variant,
  options,
  background,
  max,
  disabled,
  onChange,
  id,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (error) {
      setIsError(true);
    } else {
      setIsError(false);
    }
  }, [error, isFocused]);

  let ComponentToRender = (
    <InputVessel
      id={id}
      onFocus={() => {
        setIsFocused(true);
      }}
      onBlur={() => {
        setIsFocused(false);
      }}
      style={style}
      className={className || ""}
      required={required}
      max={max}
      type={type}
      name={name}
      value={value}
      placeholder={placeholder || ""}
      onChange={onChange}
    ></InputVessel>
  );

  if (variant === "select")
    ComponentToRender = (
      <Select
        disabled={disabled}
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={() => {
          setIsFocused(false);
        }}
        style={style}
        name={name}
        value={value}
        placeholder={placeholder || ""}
        onChange={onChange}
      ></Select>
    );
  else if (variant === "number")
    ComponentToRender = (
      <NumberFormat
        ref={null}
        value={value}
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={() => {
          setIsFocused(false);
        }}
        onValueChange={(values) => {
          onChange({
            target: {
              name,
              value: values.floatValue,
            },
          });
        }}
        maxLength={8}
        type={type}
        name={name}
        style={{
          border: "none",
          color: "rgba(0, 0, 0, 0.65)!important",
          padding: "18px 11px",
          minWidth: "250px",
          borderRadius: "7px",
          height: "60px",
          background: `${background || "#fff"}!important`,
          boxShadow: isFocused ? "0 0 0 2px rgba(24, 144, 255, 0.2)" : "none",
          outline: "none",
          transition: "all 300ms",
          zIndex: 1,

          ...style,
        }}
        placeholder="$0"
        allowNegative={false}
        isNumericString
        disabled={disabled}
        // onBlur={onBlur}
        prefix={config.prefix(type)}
        // format={config.format(type)}
        decimalScale={config.decimalScale(type)}
        // allowedDecimalSeparators={config.allowedDecimalSeparators(type)}
        allowLeadingZeros={config.allowLeadingZeros(type)}
        thousandSeparator={config.thousandSeparator(type)}
      />
    );
  else if (variant === "textarea")
    ComponentToRender = (
      <TextAreaVessel
        id={id}
        onFocus={() => {
          setIsFocused(true);
        }}
        onBlur={() => {
          setIsFocused(false);
        }}
        style={style}
        className={className || ""}
        required={required}
        name={name}
        value={value}
        placeholder={placeholder || ""}
        onChange={onChange}
      ></TextAreaVessel>
    );

  return (
    <Flex
      column
      style={{
        maxWidth: style ? style.maxWidth || "325px" : "325px",
        width: style ? style.width || "auto" : "auto",
        position: "relative",
        margin: margin || "10px 0",
      }}
    >
      {ComponentToRender}
    </Flex>
  );
};

export default Input;
